module.exports = __webpack_public_path__ + "img/check.3bfa55ac.svg";